var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgConfirmation = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Graphics/Confirmation",
  fill: "#08D48B",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.3509514,24 C5.48726752,24 0,18.7377376 0,12.3509514 C0,5.372583 5.372583,0 12.3509514,0 C18.7377376,0 24,5.48726752 24,12.3509514 C24,18.627417 18.627417,24 12.3509514,24 Z M12.3509514,23.1627907 C18.1650391,23.1627907 23.1627907,18.1650391 23.1627907,12.3509514 C23.1627907,5.94198507 18.267336,0.837209302 12.3509514,0.837209302 C5.83496093,0.837209302 0.837209302,5.83496093 0.837209302,12.3509514 C0.837209302,18.267336 5.94198507,23.1627907 12.3509514,23.1627907 Z M10.6425924,14.0412763 L15.7649849,8.41494928 L16.590413,9.16644607 L10.7310057,15.6022945 L7.58584109,12.848823 L8.32113565,12.0089296 L10.6425924,14.0412763 Z",
  id: "Combined-Shape"
})))));
export { SvgConfirmation as ReactComponent };
export default __webpack_public_path__ + "static/media/confirmation.547a1b18.svg";